const styles = theme => ({
  paragraph: {
    fontSize: '18px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  h6: {
    fontSize: '1.75rem',
    margin: '15px 0px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.25rem'
    }
  },
  h5: {
    fontSize: '2rem',
    fontWeight: 'bolder',
    margin: '15px 0px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.4rem'
    }
  },
  h4: {
    fontSize: '2.5rem',
    fontWeight: 'bolder',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.8rem'
    }
  }

});

export default styles;
